<template>
  <div>
    <div class="elasticBlockStoreResourceAzure-title">
      <div>{{ $t("RAM.Azure.trusteeDisk.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:azure:elasticBlockStoreResourceAzure:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:azure:elasticBlockStoreResourceAzure:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="elasticBlockStoreResourceAzure-top">
      <elastic-block-store-resource-azure-search
        ref="elasticBlockStoreResourceAzureSearchChild"
      ></elastic-block-store-resource-azure-search>
    </div>
    <table-elastic-block-store-resource-azure></table-elastic-block-store-resource-azure>
  </div>
</template>

<script>
import ElasticBlockStoreResourceAzureSearch from "../ebs/ElasticBlockStoreResourceAzureSearch";
import TableElasticBlockStoreResourceAzure from "../ebs/TableElasticBlockStoreResourceAzure";

export default {
  name: "ElasticBlockStoreResourceAzure",
  components: {
    ElasticBlockStoreResourceAzureSearch,
    TableElasticBlockStoreResourceAzure
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      accountNameSearchID: "",
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.elasticBlockStoreResourceAzureSearchChild.companyId;

      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 204
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.accountNameSearchID = this.$refs.elasticBlockStoreResourceAzureSearchChild.accountNameSearchKey;
      this.companyId = this.$refs.elasticBlockStoreResourceAzureSearchChild.companyId;

      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAzureDisk({
          accountName: this.accountNameSearchID,
          companyId: this.companyId
        })
        .then(res => {
          let fileName = this.$t('RAM.export.azureTrusteeDisk');
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.elasticBlockStoreResourceAzure-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.elasticBlockStoreResourceAzure-title > div:nth-child(1) {
  float: left;
}
.elasticBlockStoreResourceAzure-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.elasticBlockStoreResourceAzure-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/ebs/ElasticBlockStoreResourceAzure.vue